import React from 'react';

const RecordsHeader = ({ disabled, showAddForm, setShowAddForm }) => {
  return (
    <div className="employee-balance-header">
      <h4>Monthly Leaves Balance Records</h4>
      {!disabled && (
        <button
          type="button"
          className="employee-balance-add-btn"
          onClick={() => setShowAddForm(!showAddForm)}
        >
          {showAddForm ? "Cancel" : "Add New Balance Record"}
        </button>
      )}
    </div>
  );
};

export default RecordsHeader; 